var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "app-container" }, [_c('el-menu', { staticClass: "el-menu-demo", attrs: { "default-active": _vm.activeIndex, "mode": "horizontal", "router": "" } }, [_c('el-menu-item', { attrs: { "index": "list" } }, [_vm._v("试玩项目")]), _vm._v(" "), _c('el-menu-item', { attrs: { "index": "video-list" } }, [_vm._v("视频项目")])], 1), _vm._v(" "), _c('router-view')], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };